

import React, { lazy } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import { APP_CONFIG } from '@constants';
import NotFound from '@components/404NotFound/index';
import PrivateRoute from './privateRoute';
import withRouter from './withRouter';
import BasicLayout from './rootLayout';

const Login = withRouter(lazy(
  () => import('@containers/Login'),
));

const ForgotPassword = withRouter(lazy(
  () => import('@containers/ForgotPassword'),
));

const DashBoard = withRouter(lazy(
  () => import('@containers/DashBoard'),
));

const Home = withRouter(lazy(
  () => import('@containers/Home'),
));
const Preview = withRouter(lazy(
  () => import('@containers/Preview'),
));
const CheckIn = withRouter(lazy(
  () => import('@containers/CheckIn'),
));

const SpotScreen = withRouter(lazy(
  () => import('@containers/SpotScreen'),
));

const PickUpTime = withRouter(lazy(
  () => import('@containers/PickUpTime'),
));

const Account = withRouter(lazy(
  () => import('@containers/Account'),
));

const Profile = withRouter(lazy(
  () => import('@containers/Profile'),
));

const Wallet = withRouter(lazy(
  () => import('@containers/Wallet'),
));

const LoyaltyAccounts = withRouter(lazy(
  () => import('@containers/LoyaltyAccounts'),
));

const LoyaltyOfferDetail = withRouter(lazy(
  () => import('@containers/LoyaltyOfferDetails'),
));

const ManageAddress = withRouter(lazy(
  () => import('@containers/ManageAddress'),
));

const OrderHistory = withRouter(lazy(
  () => import('@containers/OrderHistory'),
));

const OptIn = withRouter(lazy(
  () => import('@containers/OptIn'),
));

const MyData = withRouter(lazy(
  () => import('@components/MyData'),
));

const SensorCheckIn = withRouter(lazy(
  () => import('@containers/SensorCheckIn'),
));

const AcceptTerms = withRouter(lazy(
  () => import('@containers/AcceptTerms'),
));

const GuestScreen = withRouter(lazy(
  () => import('@containers/GuestSpot'),
));

const Orders = withRouter(lazy(
  () => import('@containers/MenuOrder'),
));

const SelectedCart = withRouter(lazy(
  () => import('@containers/SelectedCart'),
));

const UpSell = withRouter(lazy(
  () => import('@containers/UpSell'),
));
const Tips = withRouter(lazy(
  () => import('@containers/Tips'),

));
const OrderItemDetail = withRouter(lazy(
  () => import ('@containers/OrderItemDetail'),

));

const Receipt = withRouter(lazy(
  () => import ('@containers/Receipt'),

));

const Survey = withRouter(lazy(
  () => import('@containers/survey'),
));

const Refill = withRouter(lazy(
  () => import('@containers/Refill')
));
const Pdf = withRouter(lazy(
  () => import('@containers/Pdf'),

));
const TableBooking = withRouter(lazy(
  () => import('@containers/TableBooking'),
));

const CheckNumber = withRouter(lazy(
  () => import('@containers/CheckNumber'),
));

const OptinTileAndPayment = withRouter(lazy(
  () => import('@containers/OptIn/optinTileAndPayment.jsx'),
));

const OrderInfo = withRouter(lazy(
  () => import('@containers/SelectedCart/OrderInfo'),
));

const SpotConfirmation = withRouter(lazy(
  () => import('@components/SpotConfirmation'),
));

const ViewReceipt = withRouter(lazy(
  () => import('@containers/ViewReceipt'),

));

const GiftCardViewReceipt = withRouter(lazy(
  () => import('@containers/ViewReceipt/giftCardVeiwReceipt'),
));
const GroupOrderGuestJoin = withRouter(lazy(
  () => import('@containers/GroupOrder/groupOrderGuestJoinCheck')
));
const OrderSuccess = withRouter(lazy(
  () => import('@containers/OrderSuccess'),
));
const PaymentOption = withRouter(lazy(
  () => import('@containers/PaymentOption'),
));
const SplitCheck = withRouter(lazy(
  () => import('@containers/SplitEvenly'),
));
const WaitList = withRouter(lazy(
  () => import('@containers/WaitList'),
));
const MyCheck = withRouter(lazy(
  () => import('@containers/MyCheck'),
));
const WaitlistConfirmation = withRouter(lazy(
  () => import('@containers/WaitlistConfirmation'),
));
const ManageWaitList = withRouter(lazy(
  () => import('@containers/ManageWaitList'),
));
const PayonlyMode = withRouter(lazy(
  () => import('@containers/PayOnlyMode'),
));

const SplitCheckList = withRouter(lazy(
  () => import('@containers/SplitCheck'),
));
const BrandStoreLocator = withRouter(lazy(
  () => import('@components/BrandStoreLocator'),
));

const BrandStoreLocationList = withRouter(lazy(
  () => import('@containers/BrandStoreLocationList'),
));

const EmployeeTableReassignment = withRouter(lazy(
  () => import('@containers/EmployeeTableReassignment'),
));
const LoyaltyLink = withRouter(lazy(
  () => import('@containers/LoyaltyLink'),
));

const PaymentSuccess = withRouter(lazy(
  () => import('@containers/PaymentSuccess'),
));
const ContactRestaurant = withRouter(lazy(
  () => import('@containers/ContactRestaurant'),

));
const MenuCategoryItems = withRouter(lazy(
  () => import('@containers/MenuCategoryItems'),
));
const MenuCategoryDetail = withRouter(lazy(
  () => import('@containers/MenuCategoryDetail'),

));
const routes = [
  {
    path: '/',
    element: <BasicLayout />,
    children: [
      { path: `${APP_CONFIG.BASE_URL}/login`, element: <Login /> },
      { path: `${APP_CONFIG.BASE_URL}/forgotpassword`, element: <ForgotPassword /> },
      { path: `${APP_CONFIG.BASE_URL}`, element: <DashBoard /> },
      { path: `${APP_CONFIG.BASE_URL}/dashboard`, element: <DashBoard /> },
      { path: `${APP_CONFIG.BASE_URL}/account`, element: <Account /> },
      { path: `${APP_CONFIG.BASE_URL}/profile/:key`, element: <Profile /> },
      { path: `${APP_CONFIG.BASE_URL}/orders-history`, element: <OrderHistory /> },
      { path: `${APP_CONFIG.BASE_URL}/mydata`, element: <MyData /> },
      { path: `${APP_CONFIG.BASE_URL}/s/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/s/:bookingId/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/sensor-check`, element: <SensorCheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/checkIn/:type/:tiketId/:referenceCode/:extraFields`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/checkIn/:type/:tiketId/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/checkIn/:type/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/kioskOrder/:tiketId/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/code`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/s/:bookingId/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/checkIn/:type/:bookingId/:referenceCode`, element: <CheckIn /> },
      { path: `${APP_CONFIG.BASE_URL}/spotnumber-confirmation`, element: <SpotConfirmation /> },
      { path: `${APP_CONFIG.BASE_URL}/:receiptType/display/:ticketId/:referenceCode`, element: <ViewReceipt /> },
      { path: `${APP_CONFIG.BASE_URL}/:receiptType/:giftCardType/display/:ticketId/:referenceCode`, element: <GiftCardViewReceipt /> },
      { path: `${APP_CONFIG.BASE_URL}/spot-screen`, element: <SpotScreen /> },
      { path: `${APP_CONFIG.BASE_URL}/payment-option`, element: <PaymentOption /> },
      { path: `${APP_CONFIG.BASE_URL}/waitlist-confirmation`, element: <WaitlistConfirmation /> },
      { path: `${APP_CONFIG.BASE_URL}/brand/:brandstorelocatorid/locator`, element: <BrandStoreLocator /> },
      { path: `${APP_CONFIG.BASE_URL}/brand/:brandstorelocatorid/listing`, element: <BrandStoreLocationList /> },
      { path: `${APP_CONFIG.BASE_URL}/employee-table-reassignment`, element: <EmployeeTableReassignment /> },
      { path: `${APP_CONFIG.BASE_URL}/wallet/loyalties/:brandExternalId/`, element: <LoyaltyLink /> },
      { path: `${APP_CONFIG.BASE_URL}/loyalty-offer-details`, element: <LoyaltyOfferDetail /> },
      { path: `${APP_CONFIG.BASE_URL}/preview/orders`, element: <Preview /> },

      {
        path: '',
        element: <PrivateRoute />,
        children: [
          { path: '/home', element: <Home /> },
          { path: `${APP_CONFIG.BASE_URL}/wallet`, element: <Wallet /> },
          { path: `${APP_CONFIG.BASE_URL}/wallet/loyalties`, element: <LoyaltyAccounts /> },
          { path: `${APP_CONFIG.BASE_URL}/wallet/address`, element: <ManageAddress /> },
          { path: `${APP_CONFIG.BASE_URL}/optIn`, element: <OptIn /> },
          { path: `${APP_CONFIG.BASE_URL}/pickup-time`, element: <PickUpTime /> },
          { path: `${APP_CONFIG.BASE_URL}/accept-terms`, element: <AcceptTerms /> },
          { path: `${APP_CONFIG.BASE_URL}/guest-spot`, element: <GuestScreen /> },
          { path: `${APP_CONFIG.BASE_URL}/orders`, element: <Orders /> },
          { path: `${APP_CONFIG.BASE_URL}/upsell`, element: <UpSell /> },
          { path: `${APP_CONFIG.BASE_URL}/selected-cart/:menuItemId`, element: <SelectedCart /> },
          { path: `${APP_CONFIG.BASE_URL}/order-item/:menuTypeId/:menuItemId`, element: <OrderItemDetail /> },
          { path: `${APP_CONFIG.BASE_URL}/order-item/:menuTypeId/:menuItemId/:internalId/:type`, element: <OrderItemDetail /> },
          { path: `${APP_CONFIG.BASE_URL}/order-child/:menuTypeId/:menuItemId`, element: <OrderItemDetail /> },
          { path: `${APP_CONFIG.BASE_URL}/tip`, element: <Tips /> },
          { path: `${APP_CONFIG.BASE_URL}/receipt`, element: <Receipt /> },
          { path: `${APP_CONFIG.BASE_URL}/receipt/:id`, element: <Receipt /> },
          { path: `${APP_CONFIG.BASE_URL}/survey`, element: <Survey /> },
          { path: `${APP_CONFIG.BASE_URL}/refill`, element: <Refill /> },
          { path: `${APP_CONFIG.BASE_URL}/specials`, element: <Pdf /> },
          { path: `${APP_CONFIG.BASE_URL}/table-booking`, element: <TableBooking /> },
          { path: `${APP_CONFIG.BASE_URL}/check-number`, element: <CheckNumber /> },
          { path: `${APP_CONFIG.BASE_URL}/orderInfo`, element: <OrderInfo /> },
          { path: `${APP_CONFIG.BASE_URL}/optin/tile/payment`, element: <OptinTileAndPayment /> },
          { path: `${APP_CONFIG.BASE_URL}/order-success`, element: <OrderSuccess /> },
          { path: `${APP_CONFIG.BASE_URL}/split-evenly`, element: <SplitCheck /> },
          { path: `${APP_CONFIG.BASE_URL}/group-order-guest-join`, element: <GroupOrderGuestJoin /> },
          { path: `${APP_CONFIG.BASE_URL}/wait-list`, element: <WaitList /> },
          { path: `${APP_CONFIG.BASE_URL}/mycheck`, element: <MyCheck /> },
          { path: `${APP_CONFIG.BASE_URL}/manage-wait-list`, element: <ManageWaitList /> },
          { path: `${APP_CONFIG.BASE_URL}/edit-wait-list/:bookingId`, element: <WaitList /> },
          { path: `${APP_CONFIG.BASE_URL}/check-paid`, element: <PayonlyMode /> },
          { path: `${APP_CONFIG.BASE_URL}/split-check`, element: <SplitCheckList /> },
          { path: `${APP_CONFIG.BASE_URL}/payment-success`, element: <PaymentSuccess /> },
          { path: `${APP_CONFIG.BASE_URL}/contact-restaurant`, element: <ContactRestaurant /> },
          { path: `${APP_CONFIG.BASE_URL}/browse-category`, element: <MenuCategoryItems /> },
          { path: `${APP_CONFIG.BASE_URL}/category-detail/:screenId`, element: <MenuCategoryDetail /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

const router = createBrowserRouter(routes);

export default (
  <div className="container-fluid p-0">
    <RouterProvider router={router} />
  </div>
);
